<template>
  <div v-ripple="{ class: 'text-indigo-lighten-4' }" class="switch-tab-item"
    :class="{ 'is-active': currentValue == value }" ref="itemRef" @click="onItemClick()">
    <slot v-if="$slots.default"></slot>
    <template v-else>{{ label }}</template>
  </div>
</template>


<script setup>
import { ref, inject, watch, onMounted, onUpdated, onBeforeUnmount, computed, useSlots, useTemplateRef } from 'vue'
import { CURRENT_VALUE, SET_CURRENT_VALUE, SET_ITEM_SIZE } from './key'

const currentValue = inject(CURRENT_VALUE)
const setCurrentValue = inject(SET_CURRENT_VALUE)
const setItemSize = inject(SET_ITEM_SIZE)


const itemRef = useTemplateRef('itemRef')


const props = defineProps({
  label: {
    type: String,
  },
  value: {
    type: [String, Number],
  }
})


onMounted(() => {
  setSize(1)
})


/**
 * 设置切换标签项的宽度和左侧偏移量
 * @param flag 1: 初始化 2: 点击
 */
function setSize(flag) {
  if (itemRef.value) {
    const width = itemRef.value.offsetWidth
    const left = itemRef.value.offsetLeft
    setItemSize({ width, left }, flag)
  }
}

function onItemClick() {
  setCurrentValue(props.value)
  setSize(2)
}



</script>

<style scoped lang="scss">
.switch-tab-item {
  cursor: pointer;
  position: relative;
  z-index: 1;
  padding: 0 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  font-family: "HarmonyOS Sans SC", sans-serif;
  transition: color 0.2s ease;

  &:hover {
    color: var(--color-primary);
  }

  &.is-active {
    color: var(--color-primary);
    font-weight: 500;
  }
}
</style>
